import { createBrowserRouter, Navigate, type RouteObject } from 'react-router-dom';
import { RequireAuth } from './auth/RequireAuth';
import { AppLayout } from './layout/AppLayout';
import { AcceptInvitePage } from './pages/auth/AcceptInvitePage';
import { LoginPage } from './pages/auth/LoginPage';
import { CollectionEditorPage } from './pages/collections/CollectionEditorPage';
import { CollectionsPage } from './pages/collections/CollectionsPage';
import { CreatorsPage } from './pages/creators/CreatorsPage';
import { HomeLayoutsPage } from './pages/home/HomeLayoutsPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { ProgrammeEditorPage } from './pages/programmes/ProgrammeEditorPage';
import { ProgrammesPage } from './pages/programmes/ProgrammesPage';
import { StaffPage } from './pages/staff/StaffPage';
import { TaxonomyPage } from './pages/taxonomy/TaxonomyPage';
import { VideosPage } from './pages/videos/VideosPage';

export const routes: RouteObject[] = [
  { path: '/login', element: <LoginPage /> },
  { path: '/accept-invite', element: <AcceptInvitePage /> },
  {
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/programmes" replace /> },
      { path: 'programmes', element: <ProgrammesPage /> },
      { path: 'programmes/:id', element: <ProgrammeEditorPage /> },
      { path: 'programmes/:id/:tab', element: <ProgrammeEditorPage /> },
      { path: 'videos', element: <VideosPage /> },
      { path: 'creators', element: <CreatorsPage /> },
      { path: 'collections', element: <CollectionsPage /> },
      { path: 'collections/:id', element: <CollectionEditorPage /> },
      { path: 'home-layouts', element: <HomeLayoutsPage /> },
      { path: 'taxonomy', element: <TaxonomyPage /> },
      { path: 'taxonomy/:vocabulary', element: <TaxonomyPage /> },
      { path: 'staff', element: <StaffPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];

export function createAppRouter() {
  return createBrowserRouter(routes, { future: { v7_relativeSplatPath: true } });
}
